import RouteParent from 'js/router/route-parent'
import CallStatusMapingsIndex from 'js/pages/call-status-mappings/index.js'

import CallStatusMappingsNew from 'js/pages/call-status-mappings/new/index.js'
import CallStatusMappingsEdit from 'js/pages/call-status-mappings/edit/index.js'

export default [
  {
    path: '/call-status-mappings',
    component: RouteParent,
    meta: {
      auth: true
    },
    children: [
      {
        //Lectura 
        path: '',
        name: 'call-status-mappings-index',
        component: CallStatusMapingsIndex,
        meta: {
          auth: true,
          permit:['VIEW_CALL_STATUS_MAPPINGS']
        }
      },
      {
        //Pantalla de creación
        path: 'new',
        name: 'call-status-mappings-new',
        component: CallStatusMappingsNew,
        meta: {
          auth: true,
          permit:['MANAGE_CALL_STATUS_MAPPINGS']
        }
      },
      {
        //Pantalla de edición (recibe el ID por la URL)
        path: ':id/edit',
        name: 'call-status-mappings-edit',
        component: CallStatusMappingsEdit,
        meta: {
          auth: true,
          permit: ['MANAGE_CALL_STATUS_MAPPINGS']
        }
      }
    ]
  }
]